var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns",style:({ background: 'url(../../../classes/' + this.code + '.png) center top / cover no-repeat' }),on:{"click":function($event){return _vm.selectClass(_vm.id)}}},[_c('div',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }